import { AccordionEntry } from '@rsa-digital/evo-shared-components/components/Accordion';
import SecondaryAccordion from '@rsa-digital/evo-shared-components/components/Accordion/SecondaryAccordion';
import { graphql } from 'gatsby';
import React from 'react';
import {
  trackAccordionCollapseClick,
  trackAccordionExpandClick,
} from 'helpers/eventTracking';
import mapNestedAccordionBlocks from '../../../../helpers/blockMappers/mapNestedAccordionBlocks';
import { NestedAccordion as NestedAccordionType } from '../types';

type NestedAccordionBlockProps = {
  nested_accordion: NestedAccordionType;
};
export const query = graphql`
  # add the top level Accordion block for a page template here, and add any flexible blocks inside that fragment in /fragments.ts
  fragment NestedAccordionBlockA on cs__template_a_blocksaccordion_accordion_entriesaccordion_entry_contentnested_accordion {
    initially_display_entries
    ...NestedAccordionEntriesTemplateAAccordion
  }

  fragment NestedAccordionBlockD on cs__template_d_blocksaccordion_accordion_entriesaccordion_entry_contentnested_accordion {
    initially_display_entries
    ...NestedAccordionEntriesTemplateDAccordion
  }

  fragment NestedAccordionBlockE on cs__template_e_blocksaccordion_accordion_entriesaccordion_entry_contentnested_accordion {
    initially_display_entries
    ...NestedAccordionEntriesTemplateEAccordion
  }

  fragment NestedAccordionBlockI on cs__template_i_blocksaccordion_accordion_entriesaccordion_entry_contentnested_accordion {
    initially_display_entries
    ...NestedAccordionEntriesTemplateIAccordion
  }

  fragment NestedAccordionBlockJ on cs__template_j_blocksaccordion_accordion_entriesaccordion_entry_contentnested_accordion {
    initially_display_entries
    ...NestedAccordionEntriesTemplateJAccordion
  }
`;

const NestedAccordionBlock: React.FC<NestedAccordionBlockProps> = ({
  nested_accordion,
}) => {
  const accordionEntries = nested_accordion.nested_accordion_entries.map(
    (entry): AccordionEntry => ({
      title: entry.nested_accordion_entry.title,
      content: mapNestedAccordionBlocks(entry.nested_accordion_entry.content), // different for different templates...
      onExpand: trackAccordionExpandClick(entry.nested_accordion_entry.title),
      onCollapse: trackAccordionCollapseClick(entry.nested_accordion_entry.title),
    })
  );
  return (
    <SecondaryAccordion
      data-cy="Nested Accordion"
      accordionEntries={accordionEntries}
      initiallyDisplayEntries={nested_accordion.initially_display_entries}
    />
  );
};
export default React.memo(NestedAccordionBlock);
